exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-afs[data-v-91a6297c]{background-color:rgba(0,255,0,.5)}.save-r[data-v-91a6297c]{background-color:hsla(0,0%,100%,.2);color:hsla(0,0%,100%,.7)}", ""]);

// exports
